export default __webpack_public_path__ + "static/media/communicationTools.cb75319e.svg";